import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('h5',[_vm._v(_vm._s(_vm.$t('loggedOutMessage')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }